import React, { useState } from "react"
import { navigate } from "gatsby"

// Libs
import VizSensor from "react-visibility-sensor"
import classnames from "classnames"

//Components
import Pic from "../images/pic"

const Component = () => {
  const [isVisible, setVisibility] = useState(false)
  let baseClass = classnames(
    { "opacity-0": !isVisible },
    { "text-slide-in": isVisible }
  )

  return (
    <section className="h-full xl:h-screen grid grid-cols-12 mb-20">
      <VizSensor
        onChange={setVisibility}
        active={!isVisible}
        partialVisibility={true}
      >
        <>
          <div className="col-span-12 col-start-2 lg:col-start-3 lg:col-span-5 pr-10 lg:mt-16 lg:mr-20">
            <div className={baseClass}>
              <h1 className="font-medium text-gray-800 text-4xl">
                Un seguro simple, rápido y económico
              </h1>
              <h1 className="text-xl font-normal tracking-wide leading-tight">
                En <b>Alex</b> creemos que contratar un seguro de vida accidental, no
                debería ser más complicado que activar una suscripción en{" "}
                <i>Netflix</i> o <i>Spotify</i>. <br /> <br /> Contrata tu
                seguro en menos de <b>cinco minutos</b> y cuenta todos los
                beneficios que necesitas en caso de un accidente, todo en <b>una misma póliza.</b>
              </h1>
              <p className="text-grayText text-xs font-light">
                Los productos Alex no son ofrecidos en USA.
              </p>
              <button
                onClick={() => {
                  navigate("quote")
                }}
                className="default-button font-bold py-4 px-6 "
              >
                Cotizar desde $9,99/mes
              </button>
            </div>
          </div>
          <div className="xl:col-span-4 xl:col-start-8 xl:pr-24 xl:pl-10 xl:py-10 lg:col-span-5 sm:p-32 p-10 pt-20 col-span-12 w-full">
            <Pic filename="home/MockupSin.png" />
          </div>
        </>
      </VizSensor>
    </section>
  )
}

export default Component
